"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transferRequestsRequestedRequested = exports.transferRequestsRequestedReceived = exports.transferRequestsReceivedRequested = exports.transferRequestsReceivedReceived = exports.transferRequestConfirmationSuccess = exports.transferRequestConfirmationSent = exports.transferRequestConfirmationFailed = exports.rejectTransferRequest = exports.getTransferRequestsRequested = exports.getTransferRequestsReceived = exports.approveTransferRequest = exports.TRANSFER_REQUEST_CONFIRMATION_SUCCESS = exports.TRANSFER_REQUEST_CONFIRMATION_SENT = exports.TRANSFER_REQUEST_CONFIRMATION_FAILED = exports.TRANSFER_REQUESTS_REQUESTED_REQUESTED = exports.TRANSFER_REQUESTS_REQUESTED_RECEIVED = exports.TRANSFER_REQUESTS_RECEIVED_REQUESTED = exports.TRANSFER_REQUESTS_RECEIVED_RECEIVED = void 0;
var _snackbarHelper = require("../../helpers/snackbarHelper");
var _apiActions = require("./apiActions");
var _snackbarActions = require("./snackbarActions");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var TRANSFER_REQUESTS_RECEIVED_REQUESTED = exports.TRANSFER_REQUESTS_RECEIVED_REQUESTED = 'TRANSFER_REQUESTS_RECEIVED_REQUESTED';
var TRANSFER_REQUESTS_RECEIVED_RECEIVED = exports.TRANSFER_REQUESTS_RECEIVED_RECEIVED = 'TRANSFER_REQUESTS_RECEIVED_RECEIVED';
var TRANSFER_REQUESTS_REQUESTED_REQUESTED = exports.TRANSFER_REQUESTS_REQUESTED_REQUESTED = 'TRANSFER_REQUESTS_REQUESTED_REQUESTED';
var TRANSFER_REQUESTS_REQUESTED_RECEIVED = exports.TRANSFER_REQUESTS_REQUESTED_RECEIVED = 'TRANSFER_REQUESTS_REQUESTED_RECEIVED';
var TRANSFER_REQUEST_CONFIRMATION_SENT = exports.TRANSFER_REQUEST_CONFIRMATION_SENT = 'TRANSFER_REQUEST_CONFIRMATION_SENT';
var TRANSFER_REQUEST_CONFIRMATION_SUCCESS = exports.TRANSFER_REQUEST_CONFIRMATION_SUCCESS = 'TRANSFER_REQUEST_CONFIRMATION_SUCCESS';
var TRANSFER_REQUEST_CONFIRMATION_FAILED = exports.TRANSFER_REQUEST_CONFIRMATION_FAILED = 'TRANSFER_REQUEST_CONFIRMATION_FAILED';

// this.t('Transfer Approved');
var approveSnackText = 'Transfer Approved';
// this.t('Transfer Rejected');
var rejectSnackText = 'Transfer Rejected';
var getTransferRequestsReceived = exports.getTransferRequestsReceived = function getTransferRequestsReceived(PayerAccountId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var OMSId, response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatch(transferRequestsReceivedRequested());
            OMSId = getState().user.userInfo.OMSId;
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetRequestTransferRequestsReceived', {
              PayerAccountId: PayerAccountId,
              OMSId: OMSId
            }));
          case 1:
            response = _context.v;
            dispatch(transferRequestsReceivedReceived(response));
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getTransferRequestsRequested = exports.getTransferRequestsRequested = function getTransferRequestsRequested() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var OMSId, selectedAccountId, response;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(transferRequestsRequestedRequested());
            OMSId = getState().user.userInfo.OMSId;
            selectedAccountId = getState().user.selectedAccountId;
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetRequestTransferRequestsRequested', {
              RequestorAccountId: selectedAccountId,
              OMSId: OMSId,
              OperatorId: 1
            }));
          case 1:
            response = _context2.v;
            if (!Array.isArray(response)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2, dispatch(transferRequestsRequestedReceived(response)));
          case 2:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'GetRequestTransferRequestsRequested',
              text: (0, _snackbarHelper.parseServerErrorMessage)('GetRequestTransferRequestsRequested', response),
              type: 'warning'
            }));
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var approveTransferRequest = exports.approveTransferRequest = function approveTransferRequest(requestCode) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var response, approved;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            dispatch(transferRequestConfirmationSent(requestCode));
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('ConfirmRequestTransferFunds', {
              OMSId: 1,
              OperatorId: 1,
              requestCode: requestCode
            }));
          case 1:
            response = _context3.v;
            approved = true;
            handleResponse(response, requestCode, approved, dispatch, getState);
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var rejectTransferRequest = exports.rejectTransferRequest = function rejectTransferRequest(requestCode) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var response, approved;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            dispatch(transferRequestConfirmationSent(requestCode));
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('RejectRequestTransferFunds', {
              OMSId: 1,
              OperatorId: 1,
              requestCode: requestCode
            }));
          case 1:
            response = _context4.v;
            approved = false;
            handleResponse(response, requestCode, approved, dispatch, getState);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var handleResponse = function handleResponse(response, requestCode, approved, dispatch, getState) {
  if (response.result) {
    dispatch(transferRequestConfirmationSuccess(response));
    var snackbarPayload = {
      id: 'confirmTransferRequestSuccess',
      text: approved ? approveSnackText : rejectSnackText,
      type: 'success'
    };
    dispatch((0, _snackbarActions.showSnack)(snackbarPayload));
    var accountId = getState().user.selectedAccountId;
    dispatch(getTransferRequestsReceived(accountId, 1));
  } else {
    dispatch(transferRequestConfirmationFailed(requestCode));
    var _snackbarPayload = {
      id: 'confirmTransferRequestFailed',
      // this.t('Failed to confirm transfer request');
      text: "".concat(response.detail ? response.detail : 'Failed to confirm transfer request', "!"),
      type: 'warning'
    };
    dispatch((0, _snackbarActions.showSnack)(_snackbarPayload));
  }
};
var transferRequestsReceivedRequested = exports.transferRequestsReceivedRequested = function transferRequestsReceivedRequested() {
  return {
    type: TRANSFER_REQUESTS_RECEIVED_REQUESTED
  };
};
var transferRequestsReceivedReceived = exports.transferRequestsReceivedReceived = function transferRequestsReceivedReceived(payload) {
  return {
    type: TRANSFER_REQUESTS_RECEIVED_RECEIVED,
    payload: payload
  };
};
var transferRequestsRequestedRequested = exports.transferRequestsRequestedRequested = function transferRequestsRequestedRequested() {
  return {
    type: TRANSFER_REQUESTS_REQUESTED_REQUESTED
  };
};
var transferRequestsRequestedReceived = exports.transferRequestsRequestedReceived = function transferRequestsRequestedReceived(payload) {
  return {
    type: TRANSFER_REQUESTS_REQUESTED_RECEIVED,
    payload: payload
  };
};
var transferRequestConfirmationSent = exports.transferRequestConfirmationSent = function transferRequestConfirmationSent(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_SENT,
    payload: payload
  };
};
var transferRequestConfirmationSuccess = exports.transferRequestConfirmationSuccess = function transferRequestConfirmationSuccess(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_SUCCESS,
    payload: payload
  };
};
var transferRequestConfirmationFailed = exports.transferRequestConfirmationFailed = function transferRequestConfirmationFailed(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_FAILED,
    payload: payload
  };
};